import { connect } from 'react-redux';

import { requestsOperations } from '../../duck';
import RecentRequestsComponent from './RecentRequestsComponent';

const mapStateToProps = (
  { requestsDuckReducer: { pendingShifts, requestTimeOffs, managedRTOs, userPrivileges, skills }, setupReducer, appReducer, scheduleCalendarReducer },
  ownProps
) => ({
  ...ownProps,
  pendingShifts: pendingShifts.data,
  locationConfig:
    setupReducer.setup_actions.meta.current_location.configuration,
  locationId:
    setupReducer.setup_actions.meta.current_location.id,
  enableVto: setupReducer?.setup_actions?.meta?.current_location?.cfg_vto || false,
  requestTimeOffs: requestTimeOffs.data,
  totalRTOs: requestTimeOffs.total,
  managedRTOs: managedRTOs.data,
  userPrivileges: userPrivileges.data,
  userPrivilegesMap: userPrivileges.dataMap,
  user: setupReducer.setup_actions.meta.current_user,
  loading: pendingShifts.loading,
  shiftsWithApplicants: pendingShifts.shiftsWithApplicants,
  fetchFailed: pendingShifts.fetchFailed,
  userIsAdmin: setupReducer.setup_actions.meta.current_user.current_is_admin,
  locationSettings: appReducer.location.settings,
  skills: appReducer.skills.data,
  channels: appReducer.channels.data,
  costCenterData: appReducer.location.costCenterData,
  departments: appReducer.departments.data,
  myDepartments: appReducer.departments.myDepartments,
  allUsers: scheduleCalendarReducer.allUsers.users,
});

const mapDispatchToProps = (dispatch) => ({
  fetchPendingShifts: () => dispatch(requestsOperations.fetchPendingShifts()),
  fetchMorePendingShifts: (pageNum, perPageNum) =>
    dispatch(requestsOperations.fetchMorePendingShifts(pageNum, perPageNum)),
  fetchPendingShiftSegments: (id) =>
    dispatch(requestsOperations.fetchPendingShiftSegments(id)),
  fetchShiftApplicants: (id, userPrivileges) =>
    dispatch(requestsOperations.fetchShiftApplicants(id, userPrivileges)),
  resetFetchFailedFlag: () => dispatch(requestsOperations.resetFetchFailedFlag),

  approvePendingShift: (shift, configId) =>
    dispatch(requestsOperations.approvePendingShift(shift, configId)),
  denyPendingShift: (shift, configId) =>
    dispatch(requestsOperations.denyPendingShift(shift, configId)),
  approveRequestTimeOff: (rto) =>
    dispatch(requestsOperations.approveRequestTimeOff(rto)),
  denyRequestTimeOff: (rto) =>
    dispatch(requestsOperations.denyRequestTimeOff(rto)),
  approveShiftApplicant: (shiftId, applicantId) =>
    dispatch(requestsOperations.approveApplicant(shiftId, applicantId)),
  denyShiftApplicant: (shiftId, applicantId) =>
    dispatch(requestsOperations.denyApplicant(shiftId, applicantId)),

});

const RecentRequestsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RecentRequestsComponent);

export default RecentRequestsContainer;
